module.exports = __webpack_public_path__ + "img/bengay_ultra_strength_topical_analgesic_cream.920b82b7.jpg";